export const UserRoles = {
  admin: 1,
  user: 2,
}
